import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { APP_TOP_BAR_HEIGHT } from './AppFrame';

const propTypes = {
  top: PropTypes.string.isRequired,
};

// Provides a sticky element inside the App Frame
const StickyInPage = styled.div`
  position: sticky;
  top: calc(${props => props.top} + ${APP_TOP_BAR_HEIGHT});
`;

StickyInPage.propTypes = propTypes;
export default StickyInPage;
